export default __webpack_public_path__ + "static/media/video6.0dfda17e.mp4";